<script type="text/javascript">
  export default {
    props: ['type', 'pc', 'website'],
    data() {
      return {
        default_content: {
          type: 'register-form',
          title: 'Register form',
          active: 1,
          image: '',
          color: 'dark',
          opacity: '',
          pad_t: '5',
          pad_r: '0',
          pad_b: '5',
          pad_l: '0',
          icon: 'ri:map-pin-user-line',
          icon_color: 'revinre',
          h2: 'Register',
          h2_color: 'white',
          h2_desc: 'Register below, or select login now if you already have an account.',
          h2_desc_color: 'gray-500',
          agreements_color: 'gray-500',
          agreements_link_color: 'revinre',
          btn1_color: 'revinre',
          btn1_text: "Register",
          link1_text: "Already have an account? Login now.",
          link1_color: "gray-500",
          link1_url: "/login",
        },
      }
    },
    created() {
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }
    },
    methods: {

    }
  }
</script>

<template>
  <section>

    <div v-if="type == 'editor'">
      <div class="p-3">
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display this section on the live website?"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section background and padding :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.image" Title="Background image URL :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.opacity" Min="0" Max="10" Title="Background color opacity :" v-tippy content="Background color transparency (0 through 10)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_t" Min="0" Max="20" Title="Top padding :" v-tippy content="Padding for the top of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_r" Min="0" Max="20" Title="Right padding :" v-tippy content="Padding for the right of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_b" Min="0" Max="20" Title="Bottom padding :" v-tippy content="Padding for the bottom of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_l" Min="0" Max="20" Title="Left padding :" v-tippy content="Padding for the left of the section (0 through 20)"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section H2 title :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.icon" Title="Section icon :" v-tippy content="Section icon"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.icon_color" Title="Section icon color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.h2" Title="H2 title :" v-tippy content="Section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_color" Title="H2 title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="Textarea" v-model="pc.h2_desc" Title="H2 description :" v-tippy content="Section description appearing below the section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_desc_color" Title="H2 description color : " :Options="theme_colors"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Agreements text :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.agreements_color" Title="Agreements color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.agreements_link_color" Title="Agreements link color : " :Options="theme_colors"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Register button :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.btn1_text" Title="Register button text :"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.btn1_color" Title="Register button color : " :Options="theme_colors"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Bottom links :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.link1_text" Title="Link 1 text :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.link1_color" Title="Link 1 color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.link1_url" Title="Link 1 URL :"></w-field>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="container-fluid">
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+(pc['image'] ? fullurlencode(pc['image']) : '')+')'"></div>
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1" :class="'bg-'+pc['color']+' _o-'+pc['opacity']"></div>
      <div class="container-fluid m_py-35" :class="'pt-'+pc['pad_t']+' pr-'+pc['pad_r']+' pb-'+pc['pad_b']+' pl-'+pc['pad_l']">
        <div class="row justify-content-center">
          <div class="col-lg-6 col-xl-3" data-aos="fade-zoom-in">

            <div class="text-center mb-5">
              <Icon v-if="pc['icon']" :icon="pc['icon']" height="45" class="mb-2" :class="'text-'+pc['icon_color']"></Icon>
              <h2 v-if="pc['h2']" class="mb-3" :class="'text-'+pc['h2_color']" data-aos="fade-zoom-in">{{pc['h2']}}</h2>
              <p v-if="pc['h2_desc']" :class="'text-'+pc['h2_desc_color']" data-aos="fade-zoom-in">{{pc['h2_desc']}}</p>
            </div>

            <form method="POST" action="/register" id="register">
              <input type="hidden" name="_token" :value="csrf">
              <input type="hidden" name="recaptcha_token" id="recaptcha_token" v-model="recaptch_key">
              <div class="form-group">
                <input type="text" placeholder="Full name" class="form-control" :class="session.errors.name ? 'is-invalid' : ''" name="name" :value="session.old.name ? session.old.name : ''" required autocomplete="name" autofocus>
                <span v-if="session.errors.name" class="invalid-feedback">{{ session.errors.name[0] }}</span>
              </div>
              <div class="form-group">
                <input type="email" placeholder="Email Address" class="form-control" :class="session.errors.email ? 'is-invalid' : ''" name="email" :value="session.old.email ? session.old.email : ''" required autocomplete="email" autofocus>
                <span v-if="session.errors.email" class="invalid-feedback">{{ session.errors.email[0] }}</span>
              </div>
              <div class="form-group">
                <input type="password" placeholder="Password" class="form-control" :class="session.errors.password ? 'is-invalid' : ''" name="password" required autocomplete="new-password">
                <span v-if="session.errors.password" class="invalid-feedback">{{ session.errors.password[0] }}</span>
              </div>
              <div class="form-group">
                <input type="password" placeholder="Confirm password" class="form-control" :class="session.errors.password_confirmation ? 'is-invalid' : ''" name="password_confirmation" required autocomplete="new-password">
                <span v-if="session.errors.password_confirmation" class="invalid-feedback">{{ session.errors.password_confirmation[0] }}</span>
              </div>

              <div class="font-weight-normal small">
                <div v-if="session.errors.recaptcha_token" class="alert alert-danger">{{ session.errors.recaptcha_token[0] }}</div>
                <p class="small mb-1" :class="'text-'+(pc['agreements_color'] ? pc['agreements_color']  : 'gray-500')">By submitting you agree to {{app_name}}'s <a href="/privacy" target="_blank" :class="(pc['agreements_link_color'] ? 'text-'+pc['agreements_link_color']  : '')">Privacy Policy</a> and <a href="/terms" target="_blank" :class="(pc['agreements_link_color'] ? 'text-'+pc['agreements_link_color']  : '')">Terms & Conditions</a>.</p>
                <p class="small" :class="'text-'+(pc['agreements_color'] ? pc['agreements_color']  : 'gray-500')">This site is protected by ReCaptcha and the Google <a href="https://policies.google.com/privacy" target="_blank" :class="(pc['agreements_link_color'] ? 'text-'+pc['agreements_link_color']  : '')">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank" :class="(pc['agreements_link_color'] ? 'text-'+pc['agreements_link_color']  : '')">Terms of Service</a> apply.</p>
              </div>

              <button v-if="pc['btn1_text']" type="submit" class="btn btn-block mt-4" :class="'btn-'+pc['btn1_color']">{{pc['btn1_text']}}</button>
              <a v-if="pc['link1_text'] && pc['link1_url']" class="d-block mt-3 text-hover-primary" :class="'text-'+pc['link1_color']" :href="pc['link1_url']">{{pc['link1_text']}}</a>
            </form>
          </div>
        </div>

      </div>
    </div>
  </section>

</template>
